const PRODUCT_ROUTES = {
    ADD_PRODUCT: 'product/add',
    GET_PRODUCT: 'product/list',
    UPDATE_PRODUCT: 'product/update',
    DELETE_PRODUCT: 'product/delete',
    CHECK_PRODUCT_UPC: 'product/check-upc',
    SELLER_ASSIGN_REQUEST: 'product/seller-assign-request',
    GET_PRODUCT_DETAILS: 'product/',
}
export default PRODUCT_ROUTES;